import angular from 'angular';

// Controllers
import ProductCenterController from './productCenterController';
import EligibilityRequirementsController from './pages/_shared/eligibilityrequirements/eligibilityRequirements.controller';
import ProductDetailController from './pages/productdetail/productDetailController';
import ProductDirectoryController from './pages/productdirectory/productDirectoryController';
import ProductSearchController from './pages/productsearch/productSearchController';
import OptionsPopupController from './pages/productsearch/optionsPopup/optionsPopupController';

// Services
import CategoryCacheService from './services/categoryCacheService';
import GEOStateCacheService from './services/geoStateCacheService';
import OptionPopupService from './services/optionPopupService';
import ProductFilterService from './services/productFilterService';
import ProductLookupService from './services/productLookupService';

// Directives
import GEOStateSelectDirective from './pages/_shared/geoStateSelect/geoStateSelect.directive'; // geoStateSelect
import GEOStateSelectController from './pages/_shared/geoStateSelect/geoStateSelect.controller';

import DirectoryBoxDirective from './pages/productdirectory/directoryBox/directoryBox.directive';
import DirectoryBoxController from './pages/productdirectory/directoryBox/directoryBox.controller';

import InputTypeGeneratorDirective from './pages/productdetail/inputTypes/inputTypeGenerator.directive';
import InputTypeCheckboxDirective from './pages/productdetail/inputTypes/directives/inputTypeCheckboxDirective';
import InputTypeDropdownDirective from './pages/productdetail/inputTypes/directives/inputTypeDropdownDirective';
import InputTypeNumericTextboxDirective from './pages/productdetail/inputTypes/directives/inputTypeNumericTextboxDirective';
import InputTypeRadioDirective from './pages/productdetail/inputTypes/directives/inputTypeRadioDirective';
import SearchFilterGeneratorDirective from './pages/productsearch/searchFilters/searchFilterGenerator.directive';
import SearchFilterCheckboxDirective from './pages/productsearch/searchFilters/directives/searchFilterCheckbox.directive';
import SearchFilterDescriptiveInputDirective from './pages/productsearch/searchFilters/directives/searchFilterDescriptiveInput.directive';
import SearchFilterMinMaxDirective from './pages/productsearch/searchFilters/directives/searchFilterMinMax.directive';
import SearchFilterNumericCheckboxDirective from './pages/productsearch/searchFilters/directives/searchFilterNumericCheckbox.directive';
import SearchFilterNumericCheckboxDynamicDirective from './pages/productsearch/searchFilters/directives/searchFilterNumericCheckboxDynamic.directive';

// Filters
import NumberFormatFilter from './filters/numberFormatFilter';
import SelectedOptionsFilter from './filters/selectedOptionsFilter';

export default angular.module('app.productLookup', [])
    .controller('ProductCenterController', ProductCenterController)
    .controller('EligibilityRequirementsController', EligibilityRequirementsController)
    .controller('ProductDetailController', ProductDetailController)
    .controller('ProductDirectoryController', ProductDirectoryController)
    .controller('ProductSearchController', ProductSearchController)
    .controller('OptionsPopupController', OptionsPopupController)
    .controller('GEOStateSelectController', GEOStateSelectController)
    .controller('DirectoryBoxController', DirectoryBoxController)

    .service('categoryCacheService', CategoryCacheService)
    .service('geoStateCacheService', GEOStateCacheService)
    .service('optionsPopupService', OptionPopupService)
    .service('productFilterService', ProductFilterService)
    .service('productLookupService', ProductLookupService)

    .directive('inputTypeGenerator', InputTypeGeneratorDirective)
    .directive('geoStateSelect', GEOStateSelectDirective)
    .directive('directoryBox', DirectoryBoxDirective)

    // input types directives
    .directive('hpInputType2', InputTypeCheckboxDirective)
    .directive('hpInputType4', InputTypeDropdownDirective)
    .directive('hpInputType1', InputTypeNumericTextboxDirective)
    .directive('hpInputType3', InputTypeRadioDirective)

    // search filters directives
    .directive('searchFilterGenerator', SearchFilterGeneratorDirective)
    .directive('searchFilters1', SearchFilterCheckboxDirective)
    .directive('searchFilters4', SearchFilterDescriptiveInputDirective)
    .directive('searchFilters6', SearchFilterMinMaxDirective)
    .directive('searchFilters2', SearchFilterNumericCheckboxDirective)
    .directive('searchFilters5', SearchFilterNumericCheckboxDynamicDirective)

    // filters
    .filter('pcNumberFormat', NumberFormatFilter)
    .filter('selectedOptions', SelectedOptionsFilter)

    .run(($templateCache) => {
        $templateCache.put('app/productCenter/productCenter.html', require('./productCenter.html')); // eslint-disable-line global-require

        // shared
        $templateCache.put('app/productCenter/pages/_shared/eligibilityrequirements/eligibilityRequirements.html', require('./pages/_shared/eligibilityrequirements/eligibilityRequirements.html')); // eslint-disable-line global-require
        $templateCache.put('app/productCenter/pages/_shared/geoStateSelect/geoStateSelect.html', require('./pages/_shared/geoStateSelect/geoStateSelect.html')); // eslint-disable-line global-require

        // product detail
        $templateCache.put('app/productCenter/pages/productdetail/productDetail.html', require('./pages/productdetail/productDetail.html')); // eslint-disable-line global-require
        $templateCache.put('app/productCenter/pages/productdetail/templates/checkbox.html', require('./pages/productdetail/inputTypes/templates/checkbox.html')); // eslint-disable-line global-require
        $templateCache.put('app/productCenter/pages/productdetail/templates/dropdown.html', require('./pages/productdetail/inputTypes/templates/dropdown.html')); // eslint-disable-line global-require
        $templateCache.put('app/productCenter/pages/productdetail/templates/numericTextbox.html', require('./pages/productdetail/inputTypes/templates/numericTextbox.html')); // eslint-disable-line global-require
        $templateCache.put('app/productCenter/pages/productdetail/templates/radio.html', require('./pages/productdetail/inputTypes/templates/radio.html')); // eslint-disable-line global-require

        // product directory
        $templateCache.put('app/productCenter/pages/productdirectory/productDirectory.html', require('./pages/productdirectory/productDirectory.html')); // eslint-disable-line global-require
        $templateCache.put('app/productCenter/pages/productdirectory/directoryBox/directoryBox.html', require('./pages/productdirectory/directoryBox/directoryBox.html')); // eslint-disable-line global-require

        // product search
        $templateCache.put('app/productCenter/pages/productsearch/productSearch.html', require('./pages/productsearch/productSearch.html')); // eslint-disable-line global-require
        $templateCache.put('app/productCenter/pages/productsearch/optionsPopup/optionsPopup.html', require('./pages/productsearch/optionsPopup/optionsPopup.html')); // eslint-disable-line global-require
        $templateCache.put('app/productCenter/pages/productsearch/searchFilters/searchFilters.html', require('./pages/productsearch/searchFilters/searchFilters.html')); // eslint-disable-line global-require

        $templateCache.put('app/productCenter/pages/productsearch/searchFilters/templates/checkbox.html', require('./pages/productsearch/searchFilters/templates/checkbox.html')); // eslint-disable-line global-require
        $templateCache.put('app/productCenter/pages/productsearch/searchFilters/templates/descriptive-input.html', require('./pages/productsearch/searchFilters/templates/descriptive-input.html')); // eslint-disable-line global-require
        $templateCache.put('app/productCenter/pages/productsearch/searchFilters/templates/minmax.html', require('./pages/productsearch/searchFilters/templates/minmax.html')); // eslint-disable-line global-require
        $templateCache.put('app/productCenter/pages/productsearch/searchFilters/templates/numeric-checkbox-dynamic.html', require('./pages/productsearch/searchFilters/templates/numeric-checkbox-dynamic.html')); // eslint-disable-line global-require
        $templateCache.put('app/productCenter/pages/productsearch/searchFilters/templates/numeric-checkbox.html', require('./pages/productsearch/searchFilters/templates/numeric-checkbox.html')); // eslint-disable-line global-require
    })
    .name;



// WEBPACK FOOTER //
// ./src/app/productCenter/index.js